import { render, staticRenderFns } from "./InformacionVentas.vue?vue&type=template&id=6f319ca2&scoped=true"
import script from "./InformacionVentas.vue?vue&type=script&lang=js"
export * from "./InformacionVentas.vue?vue&type=script&lang=js"
import style0 from "./InformacionVentas.vue?vue&type=style&index=0&id=6f319ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f319ca2",
  null
  
)

export default component.exports